export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SolarPanels: 1,
    DavidsRib: 1,
    RemovableGangway: 1,
    Wheel: 1,
    SprayHood: 1,
    BoomCover: 1,
    Boom: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'SolarPanels',
      dependency: null
    },
    {
      option: 'DavidsRib',
      dependency: null
    },
    {
      option: 'RemovableGangway',
      dependency: null
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'SprayHood',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xc47/views/exterior_view04.js